import React, {
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
  FunctionComponent
} from "react";

import styles from './Analytics.module.css';
import { Chart } from 'react-chartjs-2';
import { connect, useDispatch } from 'react-redux';
import AnalyticsCountContainer from '../../AnalyticsCountContainer/AnalyticsCountContainer';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import FeedbackGraph from '../../Components/Graphs/FeedbackGraph';
import Trends from '../../Components/Graphs/Trends';
import InterestedBudget from '../../Components/Graphs/InterestedBudget';
import InterestedProject from '../../Components/Graphs/InterestedProject';
import InterestedLocation from '../../Components/Graphs/InterestedLocation';
import CompletedTask from '../../Components/Graphs/CompletedTask';
import OverdueTask from '../../Components/Graphs/OverdueTask';
import PendingTask from '../../Components/Graphs/PendingTask';
import NotIntReason from '../../Components/Graphs/NotIntReason';
import LostReason from '../../Components/Graphs/LostReason';
import { FaFilter } from 'react-icons/fa';
import { FaBeer } from 'react-icons/fa';
import { FaUsers } from 'react-icons/fa';
import { FaBook } from 'react-icons/fa';
import AnalyticsFilter from '../../Components/AnalyticsFilter/AnalyticsFilter';
import axios from 'axios';
import Loading from '../../Components/Loading/Loading';
import moment from 'moment';
import Firebase from 'firebase/app';
import { url } from '../../Values/constants';
import KanbanViewFilter from '../../Components/Modals/KanbanViewModal/KanbanViewModal';
import './tabs.style.css';
import {
  feedbackReportData,
  interestedBudgetReportData,
  interestedLocationReportData,
  interestedProjectReportData,
  interestedPropertyTypeReportData,
  interestedPropertyStageReportData,
  lostReasonReportData,
  notInterestedReportData,
  completeTaskReportData,
  pendingReportData,
  overDueReportData,
  callBackReasonReportData,
  callBackReportData,
} from '../../Redux/actions';
import { themeColors } from "../../Components/theme";
import CallBackReason from '../../Components/Graphs/CallBackReason';
import { sortDates } from '../../Services/analytics';
import { fetchOrganizationsUsersAuthId } from '../../Services/users';
import { Box, Grid, useMediaQuery, useTheme, Container } from "@mui/material";
import "../../theme-vars.css";

Chart.register(ChartDataLabels);
Chart.defaults.set('plugins.datalabels', {
  color: '#FFFFFF',
});

// all from redux store
type props = {
  user: any;
  organizationUsers: any;
  teamLeadUsers: any;
  role: any;
  history: any;
  branchUsers: any;
  clearfiltersideBar: any;
  theme: any;
  authToken: any;
  organizationIdNameData: any;
  conatctHeader: any;
  analyticsPanel: any;
};

const AdminAnalytics: FunctionComponent<props> = ({
  user,
  organizationUsers,
  teamLeadUsers,
  role,
  history,
  branchUsers,
  clearfiltersideBar,
  theme,
  authToken,
  organizationIdNameData,
  conatctHeader,
  analyticsPanel
}) => {
  //filter show, hide
  const themeMUI = useTheme();
  const isMobile = useMediaQuery(themeMUI.breakpoints.down("sm"));

  const lastApiKeyRef = useRef<string>("");

  const [showFilter, setShowFilter] = useState(false);
  const [showOrgFilter, setShowOrgFilter] = useState(false);
  const [callLogAnalytics, setCallLogAnalytics] = useState({});
  const [analyticsData, setAnalyticsData] = useState<any>({});
  const [apiAnalyticsData, setApiAnalyticsData] = useState<any>({});
  const [apiCallLogAnalyticsData, setCallLogApiAnalyticsData] = useState<any>({});
  const [taskAnalyticsData, setTaskAnalyticsData] = useState<any>({});

  // check to show show data team wise or for all team members
  const [checked, setChecked] = useState(false);
  const [load, setLoad] = useState(false);

  // to check if the status is source or associate
  const [source, setSource] = useState(false);
  const [interestedTrendAnalytics, setInterestedTrendAnalytics] = useState<any>({});
  const [analyticsType, setAnalyticsType] = useState('associate');
  const [clearFilter, setClearFilter] = useState(false);
  const [total, setTotal] = useState(0);
  const [usersList, setUsersList] = useState<any>({});
  const [usersEmail, setUsersEmail] = useState<any[]>([]);
  const [teamsData, setTeamsData] = useState<any>({});
  const [filterType, setFilterType] = useState<any>('All');
  const [contactsFilter, setContactsFilter] = useState<any>({});
  const [tasksFilter, setTasksFilter] = useState<any>({});
  const [callsFilter, setCallsFilter] = useState({});
  const [passOnTaskFilters, setPassOnTaskFilter] = useState<any>({});
  const [passOnContactFilters, setPassOnContactFilters] = useState<any>({});
  const [showMoreContactAnalytics, setShowMoreContactAnalytics] = useState(false);
  const [showTrendAnalytics, setShowTrendAnalytics] = useState(false);
  const [organizationSelectId, setOrganizationSelectId] = useState<any>(organizationIdNameData[0]);
  const dispatcher = useDispatch();
  const dateFilterBtnRef = useRef<HTMLButtonElement>(null);
  const [showKanbanFilter, setShowKanbanFilter] = useState(false);
  const kanbanBtnRef = useRef<HTMLButtonElement>(null);
  const [kanbanAnchor, setKanbanAnchor] = useState<{ top: number, left: number } | null>(null);

  const [stage, setStage] = useState<any>({
    INTERESTED: 0,
    FRESH: 0,
    CALLBACK: 0,
    WON: 0,
    LOST: 0,
    Pending: 0,
    Completed: 0,
    'NOT INTERESTED': 0,
  });

  const [taskStage, setTaskStage] = useState<any>({
    Pending: 0,
    Completed: 0,
  });

  const [overdueTrend, setOverdueTrend] = useState<{
    keys: any[];
    values: any[];
  }>({ keys: [], values: [] });

  const [completeTrend, setCompleteTrend] = useState<{
    keys: any[];
    values: any[];
  }>({ keys: [], values: [] });

  const [callLogData, setCallLogData] = useState<{ data: any[]; label: any[] }>(
    { data: [], label: [] }
  );

  const [interestedData, setInterestedData] = useState<{
    data: any[];
    label: any[];
  }>({ data: [], label: [] });

  const memoContactsFilter = useMemo(
    () => contactsFilter,
    [JSON.stringify(contactsFilter)]
  );

  const memoTasksFilter = useMemo(
    () => tasksFilter,
    [JSON.stringify(tasksFilter)]
  );

  const memoCallsFilter = useMemo(
    () => callsFilter,
    [JSON.stringify(callsFilter)]
  );

  const getApiKey = () =>
    JSON.stringify({
      analyticsType,
      analyticsPanel,
      filterType,
      memoContactsFilter,
      memoTasksFilter,
      memoCallsFilter,
      userId: user?.auth_id,
    });

  useEffect(() => {
    const contactFilterObj = localStorage.getItem("contactFilterObj") || "";
    const taskFilterObj = localStorage.getItem("taskFilterObj") || "";
    const callFilterObj = localStorage.getItem("callFilterObj") || "";
    const contactObj = contactFilterObj ? JSON.parse(contactFilterObj) : {};

    let contactFilObj: { [key: string]: [] } = {};

    Object.entries(contactObj).map(([key, value]) => {
      if (contactObj[key].length > 0) {

        if (key === "transfer_status") {
          contactFilObj[key] = contactObj[key]?.map((va: any) => {
            return va?.value ? va?.value === "False" ? false : true : va === "False" ? false : true;
          });
        } else {
          contactFilObj[key] = contactObj[key]?.map((va: any) => {
            return va?.value ? va?.value : va;
          });
        }
      }
      else {
        return {};
      }
    })

    setContactsFilter({ ...contactFilObj });
    const taskObj = taskFilterObj ? JSON.parse(taskFilterObj) : {};

    let taskFilObj: { [key: string]: [] } = {};
    Object.entries(taskObj).map(([key, value]) => {
      if (taskObj[key].length > 0) {
        taskFilObj[key] = taskObj[key]?.map((va: any) => {
          return va?.value ? va?.value : va;
        });
      }
      else {
        return {};
      }
    })
    setTasksFilter(taskFilObj);
    const callObj = callFilterObj ? JSON.parse(callFilterObj) : {};
    let callFilObj: { [key: string]: [] } = {};
    Object.entries(callObj).map(([key, value]) => {
      if (callObj[key].length > 0) {
        callFilObj[key] = callObj[key]?.map((va: any) => {
          return va?.value ? va?.value : va;
        });
      }
      else {
        return {};
      }
    })
    setCallsFilter(callFilObj);
  }, [analyticsPanel]);

  useEffect(() => {
    let teams: { [key: string]: string } = {};
    if (organizationUsers) {
      organizationUsers.map((user: any) => {
        teams[user?.auth_id] = user.team;
      });
      setTeamsData(teams);
    }
  }, [user, teamLeadUsers, organizationUsers]);

  useEffect(() => {
    if (user.user_email === "info@leadsrubix.com") {
      const localStoreOrgObj = localStorage.getItem("superAdminSelectedOrg");
      if (localStoreOrgObj != null) {
        const covertObj = JSON.parse(localStoreOrgObj);
        const orgAuthId = covertObj.value;

        if (orgAuthId) {
          const unSub = fetchOrganizationsUsersAuthId(
            dispatcher,
            orgAuthId,
            user
          );
          return () => {
            unSub();
          };
        }
      }
    }
  }, [localStorage.getItem("superAdminSelectedOrg")]);

  const triggerAnalyticsApi = useCallback(() => {
    if (!authToken || !user?.auth_id) return;

    const apiKey = getApiKey();

    // SAME request = do not hit again
    if (lastApiKeyRef.current === apiKey) return;

    lastApiKeyRef.current = apiKey;

    if (analyticsType === "associate") {
      callAnalyticsApi();
    } else {
      callSourceAnalyticsApi();
    }
  }, [
    analyticsType,
    analyticsPanel,
    filterType,
    memoContactsFilter,
    memoTasksFilter,
    memoCallsFilter,
    authToken,
    user?.auth_id,
  ]);

  useEffect(() => {
    triggerAnalyticsApi();
  }, [triggerAnalyticsApi]);

  useEffect(() => {
    lastApiKeyRef.current = "";
  }, [
    analyticsPanel,
    analyticsType,
    filterType,
    memoContactsFilter,
    memoTasksFilter,
    memoCallsFilter,
  ]);

  // function to call the call logs analytics api
  const callAnalyticsApi = async () => {
    let startDate;
    let endDate;
    setLoad(true);
    setShowOrgFilter(false);
    // Month till date
    if (filterType === 'MTD') {
      const startOfMonth = moment().startOf('month').toDate();
      startDate = startOfMonth;
      endDate = Firebase.firestore.Timestamp.now().toDate();
    }
    // previous month
    else if (filterType === 'PM') {
      const prevMonth = moment().subtract(1, 'M');
      const prevMonthStart = prevMonth.startOf('month').toDate();
      const prevMonthEnd = prevMonth.endOf('month').toDate();
      startDate = prevMonthStart;
      endDate = prevMonthEnd;
    }
    // today
    else if (filterType === 'T') {
      const todayStart = moment().startOf('day').toDate();
      const todayEnd = moment().endOf('day').toDate();
      startDate = todayStart;
      endDate = todayEnd;
    }
    // yesterday
    else if (filterType === 'Y') {
      const prevDay = moment().subtract(1, 'day');
      const prevDayStart = prevDay.startOf('day').toDate();
      const prevDayEnd = prevDay.endOf('day').toDate();
      startDate = prevDayStart;
      endDate = prevDayEnd;
    }
    // we have three modules - call logs, tasks and contacts
    // if we want filters of other modules in current modules, we need to send the api data such that it includes the module name before the filter attribute
    // as for the same module filter, we can send the filter attribute name as it is


    if (analyticsPanel === 'Contacts' || analyticsPanel === 'Tasks') {
      let filtersLeads: { [key: string]: any } = {};
      let filtersTasks: { [key: string]: any } = {};

      Object.keys(tasksFilter).forEach((key) => {
        filtersTasks[`tasks.${key}`] = tasksFilter[key];
      });

      Object.keys(contactsFilter).forEach((key) => {
        if (key === "created_at") {
          filtersLeads[key] = contactsFilter[key];
        }
        else {
          filtersLeads[`leads.${key}`] = contactsFilter[key];
        }
      });

      setPassOnContactFilters(filtersLeads);
      setPassOnTaskFilter(filtersTasks);
      let analytics: {
        [key: string]: {
          leadAnalytics: {
            budget: {};
            stage: {};
            location: {};
            project: {};
            propertyType: {};
            propertyStage: {};
            lost_reason: {};
            not_int_reason: {};
            call_back_reason: {};
          };
        };
      } = {};

      let taskAnalytics: {
        [key: string]: {
          totalTaskCount: { Pending: {}; Overdue: {}; Completed: {} };
        };
      } = {};

      axios.defaults.headers.common['x-access-token'] = authToken;

      const { reporting_to, team, branch, lead_source, transfer_status, ...otherContactFilter } = contactsFilter;
      // api chart api data
      const apiDataBody = {
        uid: user?.auth_id,
        start_date: startDate,
        end_date: endDate,
        taskFilter: filtersTasks,
        leadFilter: { ...otherContactFilter, },
        leadUserFilter: {
          reporting_to,
          team,
          branch
        },
        callFilter: callsFilter,
      };

      const tasksApiData = {
        uid: user?.auth_id,
        start_date: startDate,
        end_date: endDate,
        taskFilter: { ...tasksFilter, transfer_status },
        leadFilter: { 'source': lead_source, ...otherContactFilter },
        leadUserFilter: {
          reporting_to,
          team,
          branch
        },
        callFilter: callsFilter,
      };

      // api chart api call
      const apiCallPromise = await axios.post(
        url + '/analyticsLeads/dashboard/associate',
        apiDataBody
      );

      // pending task chart and report api call
      const taskPromise = await axios.post(
        url + '/analyticsTasks/dashboard/associate',
        tasksApiData
      );

      Promise.all([apiCallPromise, taskPromise]).then((data) => {
        let apiResponseData: any = data[0];
        let taskResponseData: any = data[1];
        let pendingCount = 0;

        dispatcher(feedbackReportData(apiResponseData.data?.feedback?.report));

        // converting feedback report data in required format for our chart and report
        if (apiResponseData.data?.feedback?.report) {
          apiResponseData.data.feedback.report?.forEach((item: any) => {
            let stage: { [key: string]: number } = {};
            item.stage.forEach((val: any) => {
              stage[val.stage] = val.count;
            });
            analytics[item.owner] = {
              leadAnalytics: {
                stage: stage,
                budget: {},
                location: {},
                project: {},
                propertyType: {},
                propertyStage: {},
                lost_reason: {},
                not_int_reason: {},
                call_back_reason: {}
              },
            };
          });
        }

        dispatcher(callBackReasonReportData(apiResponseData.data?.callBackReason?.report));
        if (apiResponseData.data?.callBackReason?.report) {
          apiResponseData.data?.callBackReason?.report.forEach((item: any) => {
            let call_back_reason: { [key: string]: number } = {};
            item.call_back_reason.forEach((val: any) => {
              call_back_reason[val.call_back_reason] = val.count;
            });
            analytics[item.owner] = {
              leadAnalytics: {
                budget: {},
                location: {},
                project: {},
                propertyType: {},
                propertyStage: {},
                lost_reason: {},
                not_int_reason: {},
                stage: { ...analytics[item.owner].leadAnalytics.stage },
                call_back_reason: call_back_reason,
              },
            };
          });
        }

        dispatcher(interestedBudgetReportData(apiResponseData.data?.interested?.budget?.report));
        // converting budget report data in required format for our chart and report
        if (apiResponseData.data?.interested?.budget?.report) {
          apiResponseData.data?.interested?.budget?.report?.forEach((item: any) => {
            let budget: { [key: string]: number } = {};
            item.budget.forEach((val: any) => {
              budget[val.budget] = val.count;
            });
            analytics[item.owner] = {
              leadAnalytics: {
                budget: budget,
                stage: { ...analytics[item.owner].leadAnalytics.stage },
                location: {},
                project: {},
                propertyType: {},
                propertyStage: {},
                lost_reason: {},
                not_int_reason: {},
                call_back_reason: { ...analytics[item.owner].leadAnalytics.call_back_reason },
              },
            };
          });
        }

        dispatcher(interestedLocationReportData(apiResponseData.data?.interested?.location?.report));
        // converting location report data in required format for our chart and report
        if (apiResponseData.data?.interested?.location?.report) {
          apiResponseData.data.interested.location.report.forEach((item: any) => {
            let location: { [key: string]: number } = {};
            item.location.forEach((val: any) => {
              location[val.location] = val.count;
            });
            analytics[item.owner] = {
              leadAnalytics: {
                location: location,
                budget: { ...analytics[item.owner].leadAnalytics.budget },
                stage: { ...analytics[item.owner].leadAnalytics.stage },
                project: {},
                propertyType: {},
                propertyStage: {},
                lost_reason: {},
                not_int_reason: {},
                call_back_reason: { ...analytics[item.owner].leadAnalytics.call_back_reason },
              },
            };
          });
        }

        dispatcher(interestedProjectReportData(apiResponseData.data?.interested?.project?.report));
        if (apiResponseData.data?.interested?.project?.report) {
          apiResponseData.data.interested.project.report.forEach((item: any) => {
            let project: { [key: string]: number } = {};
            item.project.forEach((val: any) => {
              project[val.project] = val.count;
            });
            analytics[item.owner] = {
              leadAnalytics: {
                project: project,
                location: { ...analytics[item.owner].leadAnalytics.location },
                budget: { ...analytics[item.owner].leadAnalytics.budget },
                stage: { ...analytics[item.owner].leadAnalytics.stage },
                propertyType: {},
                propertyStage: {},
                lost_reason: {},
                not_int_reason: {},
                call_back_reason: { ...analytics[item.owner].leadAnalytics.call_back_reason },
              },
            };
          });
        }

        dispatcher(interestedPropertyTypeReportData(apiResponseData.data?.interested?.propertyType?.report));
        if (apiResponseData.data?.interested?.propertyType?.report) {
          apiResponseData.data?.interested?.propertyType?.report.forEach((item: any) => {
            let propertyType: { [key: string]: number } = {};
            item.property_type.forEach((val: any) => {
              propertyType[val.property_type] = val.count;
            });
            analytics[item.owner] = {
              leadAnalytics: {
                propertyType: propertyType,
                project: { ...analytics[item.owner].leadAnalytics.project },
                location: { ...analytics[item.owner].leadAnalytics.location },
                budget: { ...analytics[item.owner].leadAnalytics.budget },
                stage: { ...analytics[item.owner].leadAnalytics.stage },
                propertyStage: {},
                lost_reason: {},
                not_int_reason: {},
                call_back_reason: { ...analytics[item.owner].leadAnalytics.call_back_reason },
              },
            };
          });
        }

        dispatcher(interestedPropertyStageReportData(apiResponseData.data?.interested?.propertyStage?.report));
        if (apiResponseData.data?.interested?.propertyStage?.report) {
          apiResponseData.data.interested.propertyStage.report.forEach((item: any) => {
            let propertyStage: { [key: string]: number } = {};
            item.property_stage.forEach((val: any) => {
              propertyStage[val.property_stage] = val.count;
            });
            analytics[item.owner] = {
              leadAnalytics: {
                propertyStage: propertyStage,
                propertyType: {
                  ...analytics[item.owner].leadAnalytics.propertyType,
                },
                project: { ...analytics[item.owner].leadAnalytics.project },
                location: { ...analytics[item.owner].leadAnalytics.location },
                budget: { ...analytics[item.owner].leadAnalytics.budget },
                stage: { ...analytics[item.owner].leadAnalytics.stage },
                lost_reason: {},
                not_int_reason: {},
                call_back_reason: { ...analytics[item.owner].leadAnalytics.call_back_reason },
              },
            };
          });
        }

        dispatcher(lostReasonReportData(apiResponseData.data?.reasons?.lostReason?.report));
        if (apiResponseData.data?.reasons?.lostReason?.report) {
          apiResponseData.data?.reasons?.lostReason?.report.forEach((item: any) => {
            let lost_reason: { [key: string]: number } = {};
            item.lost_reason.forEach((val: any) => {
              lost_reason[val.lost_reason] = val.count;
            });
            analytics[item.owner] = {
              leadAnalytics: {
                lost_reason: lost_reason,
                propertyStage: {
                  ...analytics[item.owner].leadAnalytics.propertyStage,
                },
                propertyType: {
                  ...analytics[item.owner].leadAnalytics.propertyType,
                },
                project: { ...analytics[item.owner].leadAnalytics.project },
                location: { ...analytics[item.owner].leadAnalytics.location },
                budget: { ...analytics[item.owner].leadAnalytics.budget },
                stage: { ...analytics[item.owner].leadAnalytics.stage },
                not_int_reason: {},
                call_back_reason: { ...analytics[item.owner].leadAnalytics.call_back_reason },
              },
            };
          });
        }

        dispatcher(notInterestedReportData(apiResponseData.data?.reasons?.notInterestedReason?.report));
        if (apiResponseData.data?.reasons?.notInterestedReason?.report) {
          apiResponseData.data.reasons.notInterestedReason.report.forEach((item: any) => {
            let not_int_reason: { [key: string]: number } = {};
            item.not_int_reason.forEach((val: any) => {
              not_int_reason[val.not_int_reason] = val.count;
            });
            analytics[item.owner] = {
              leadAnalytics: {
                not_int_reason: not_int_reason,
                lost_reason: {
                  ...analytics[item.owner].leadAnalytics.lost_reason,
                },
                propertyStage: {
                  ...analytics[item.owner].leadAnalytics.propertyStage,
                },
                propertyType: {
                  ...analytics[item.owner].leadAnalytics.propertyType,
                },
                project: { ...analytics[item.owner].leadAnalytics.project },
                location: { ...analytics[item.owner].leadAnalytics.location },
                budget: { ...analytics[item.owner].leadAnalytics.budget },
                stage: { ...analytics[item.owner].leadAnalytics.stage },
                call_back_reason: { ...analytics[item.owner].leadAnalytics.call_back_reason },
              },
            };
          });
        }

        // converting pending task report data in required format for our chart and report
        dispatcher(pendingReportData(taskResponseData.data?.tasks?.pending?.report));
        if (taskResponseData.data?.tasks?.pending?.report) {
          taskResponseData.data.tasks.pending.report.forEach((item: any) => {
            let pending: { [key: string]: number } = {};
            item.type.forEach((val: any) => {
              pending[val.type] = val.count;
              if (val.type === 'Meeting' || val.type === 'Site Visit') {
                pendingCount = pendingCount + val.count;
              }
            });
            taskAnalytics[item.owner] = {
              totalTaskCount: {
                Pending: pending,
                Overdue: { Meeting: 0, 'Call Back': 0, 'Site Visit': 0 },
                Completed: { Meeting: 0, 'Call Back': 0, 'Site Visit': 0 },
              },
            };
          });
        }

        dispatcher(overDueReportData(taskResponseData.data?.tasks?.overdue?.report));
        // converting overdue task report data in required format for our chart and report
        if (taskResponseData.data?.tasks?.overdue?.report) {
          taskResponseData.data.tasks.overdue.report.forEach((item: any) => {
            let overdue: { [key: string]: number } = {};
            item.type.forEach((val: any) => {
              overdue[val.type] = val.count;
              if (val.type === 'Meeting' || val.type === 'Site Visit') {
                pendingCount = pendingCount + val.count;
              }
            });
            if (taskAnalytics[item.owner] === undefined) {
              taskAnalytics[item.owner] = {
                totalTaskCount: {
                  Pending: { Meeting: 0, 'Call Back': 0, 'Site Visit': 0 },
                  Overdue: overdue,
                  Completed: { Meeting: 0, 'Call Back': 0, 'Site Visit': 0 },
                },
              };
            } else {
              taskAnalytics[item.owner] = {
                totalTaskCount: {
                  Pending: {
                    ...taskAnalytics[item.owner].totalTaskCount.Pending,
                  },
                  Overdue: overdue,
                  Completed: { Meeting: 0, 'Call Back': 0, 'Site Visit': 0 },
                },
              };
            }
          });
        }
        dispatcher(completeTaskReportData(taskResponseData.data?.tasks?.completed?.report));
        let completedCount = 0;

        // converting completed task report data in required format for our chart and report
        if (taskResponseData.data?.tasks?.completed?.report) {
          taskResponseData.data.tasks.completed.report.forEach((item: any) => {
            let completed: { [key: string]: number } = {};
            item.type.forEach((val: any) => {
              completed[val.type] = val.count;
              if (val.type === 'Meeting' || val.type === 'Site Visit') {
                completedCount = completedCount + val.count;
              }
            });
            if (taskAnalytics[item.owner] === undefined) {
              taskAnalytics[item.owner] = {
                totalTaskCount: {
                  Pending: { Meeting: 0, 'Call Back': 0, 'Site Visit': 0 },
                  Overdue: { Meeting: 0, 'Call Back': 0, 'Site Visit': 0 },
                  Completed: completed,
                },
              };
            } else {
              taskAnalytics[item.owner] = {
                totalTaskCount: {
                  Pending: {
                    ...taskAnalytics[item.owner].totalTaskCount.Pending,
                  },
                  Overdue: {
                    ...taskAnalytics[item.owner].totalTaskCount.Overdue,
                  },
                  Completed: completed,
                },
              };
            }
          });
        }
        setTaskStage({ Completed: completedCount, Pending: pendingCount });
        setTaskAnalyticsData(taskAnalytics);
        setApiAnalyticsData(analytics);
        setLoad(false);
      })
    }

    if (analyticsPanel === 'Call Logs') {
      let filters: { [key: string]: any } = {};
      Object.keys(contactsFilter).forEach((key) => {
        filters[`leads.${key}`] = contactsFilter[key];
      });
      setPassOnContactFilters(filters);
      let Tasksfilters: { [key: string]: any } = {};
      Object.keys(tasksFilter).forEach((key) => {
        Tasksfilters[`tasks.${key}`] = tasksFilter[key];
      });
      setPassOnTaskFilter(Tasksfilters);

      // access token for api call
      axios.defaults.headers.common['x-access-token'] =
        authToken

      const { reporting_to, team, branch, transfer_status, ...otherContactFilter } = contactsFilter;

      // call logs report api data
      const callLogsApiData = {
        uid: user?.auth_id,
        start_date: startDate,
        end_date: endDate,
        taskFilter: Tasksfilters || {},
        leadFilter: otherContactFilter,
        leadUserFilter: {
          reporting_to,
          team,
          branch
        },
        callFilter: { ...callsFilter, transfer_status },
      };

      const callingReportPromise = await axios.post(
        url + '/analyticsCalls/dashboard/associate',
        callLogsApiData
      );

      Promise.all([callingReportPromise]).then((data) => {
        let callLogsRes: any = data[0];

        setInterestedTrendAnalytics(callLogsRes?.data?.interestedStage.ChartCount);
        dispatcher(callBackReportData(callLogsRes?.data?.calls));

        // setting call logs report data in required format for our chart and report
        if (callLogsRes.data?.calls) {
          const obj = Object.assign({}, ...(callLogsRes.data?.calls?.ChartCount || []));
          let callsData: { [key: string]: { callLogAnalytics: {} } } = {};
          (callLogsRes.data?.calls?.report || []).forEach((item: any) => {
            let data: {
              '0 sec': number;
              '0-30 sec': number;
              '31-60 sec': number;
              '61-120 sec': number;
              '>120 sec': number;
            } = { '0 sec': 0, '0-30 sec': 0, '31-60 sec': 0, '61-120 sec': 0, '>120 sec': 0 };

            (item.duration || []).forEach((val: any) => {
              if (val.duration === 0) {
                data['0 sec'] = val.count;
              } else if (val.duration === 30) {
                data['0-30 sec'] = val.count;
              } else if (val.duration === 60) {
                data['31-60 sec'] = val.count;
              } else if (val.duration === 120) {
                data['61-120 sec'] = val.count;
              } else {
                data['>120 sec'] = val.count;
              }
            });
            callsData[item.owner] = { callLogAnalytics: data };
          });
          setCallLogApiAnalyticsData(callsData);
          setCallLogAnalytics(obj);
          setLoad(false);
        }
      });
    }
  };

  // same as above, just for source type
  const callSourceAnalyticsApi = async () => {
    let startDate;
    let endDate;
    setLoad(true);
    setShowOrgFilter(false)
    // Month till date
    if (filterType === 'MTD') {
      const startOfMonth = moment().startOf('month').toDate();
      startDate = startOfMonth;
      endDate = Firebase.firestore.Timestamp.now().toDate();
    }
    // previous month
    else if (filterType === 'PM') {
      const prevMonth = moment().subtract(1, 'M');
      const prevMonthStart = prevMonth.startOf('month').toDate();
      const prevMonthEnd = prevMonth.endOf('month').toDate();
      startDate = prevMonthStart;
      endDate = prevMonthEnd;
    }
    // today
    else if (filterType === 'T') {
      const todayStart = moment().startOf('day').toDate();
      const todayEnd = moment().endOf('day').toDate();
      startDate = todayStart;
      endDate = todayEnd;
    }
    // yesterday
    else if (filterType === 'Y') {
      const prevDay = moment().subtract(1, 'day');
      const prevDayStart = prevDay.startOf('day').toDate();
      const prevDayEnd = prevDay.endOf('day').toDate();
      startDate = prevDayStart;
      endDate = prevDayEnd;
    }

    if (analyticsPanel === 'Contacts' || analyticsPanel === 'Tasks') {
      const { reporting_to, team, branch, lead_source, ...otherContactFilter } = contactsFilter;

      let filtersLeads: { [key: string]: any } = {};
      let filtersTasks: { [key: string]: any } = {};

      Object.keys(tasksFilter).forEach((key) => {
        filtersTasks[`tasks.${key}`] = tasksFilter[key];
      });

      Object.keys(contactsFilter).forEach((key) => {
        if (key === "created_at") {
          filtersLeads[key] = contactsFilter[key];
        }
        else {
          filtersLeads[`leads.${key}`] = contactsFilter[key];
        }
      });

      setPassOnContactFilters(filtersLeads);
      setPassOnTaskFilter(filtersTasks);

      let analytics: {
        [key: string]: {
          leadAnalytics: {
            budget: {};
            stage: {};
            location: {};
            project: {};
            propertyType: {};
            propertyStage: {};
            lost_reason: {};
            not_int_reason: {};
            call_back_reason: {};
          };
        };
      } = {};

      let taskAnalytics: {
        [key: string]: {
          totalTaskCount: { Pending: {}; Overdue: {}; Completed: {} };
        };
      } = {};

      axios.defaults.headers.common['x-access-token'] = authToken;

      // api chart api data
      const apiDataBody = {
        uid: user?.auth_id,
        start_date: startDate,
        end_date: endDate,
        taskFilter: filtersTasks,
        leadFilter: { ...otherContactFilter, },
        leadUserFilter: {
          reporting_to,
          team,
          branch
        },
        callFilter: callsFilter,
      };

      const tasksApiData = {
        uid: user?.auth_id,
        start_date: startDate,
        end_date: endDate,
        taskFilter: tasksFilter,
        leadFilter: { 'source': lead_source, ...otherContactFilter },
        leadUserFilter: {
          reporting_to,
          team,
          branch
        },
        callFilter: callsFilter,
      };

      // api chart api call
      const apiCallPromise = await axios.post(
        url + '/analyticsLeads/dashboard/source',
        apiDataBody
      );

      // pending task chart and report api call
      const taskPromise = await axios.post(
        url + '/analyticsTasks/dashboard/source',
        tasksApiData
      );

      Promise.all([apiCallPromise, taskPromise]).then(data => {
        let pendingCount = 0;
        let apiResponseData: any = data[0];
        let taskResponseData: any = data[1];

        dispatcher(feedbackReportData(apiResponseData.data?.feedback?.report));

        if (apiResponseData.data?.feedback?.report) {
          apiResponseData.data.feedback?.report.forEach((item: any) => {
            let stage: { [key: string]: number } = {};
            item.stage.forEach((val: any) => {
              stage[val.stage] = val.count;
            });
            analytics[item.lead_source] = {
              leadAnalytics: {
                stage: stage,
                budget: {},
                location: {},
                project: {},
                propertyType: {},
                propertyStage: {},
                lost_reason: {},
                not_int_reason: {},
                call_back_reason: {}
              },
            };
          });
        }
        dispatcher(callBackReasonReportData(apiResponseData.data?.callBackReason?.report));
        if (apiResponseData.data?.callBackReason?.report) {
          apiResponseData.data.callBackReason.report.forEach((item: any) => {
            let call_back_reason: { [key: string]: number } = {};
            item.call_back_reason.forEach((val: any) => {
              call_back_reason[val.call_back_reason] = val.count;
            });
            analytics[item.lead_source] = {
              leadAnalytics: {
                budget: {},
                location: {},
                project: {},
                propertyType: {},
                propertyStage: {},
                lost_reason: {},
                not_int_reason: {},
                stage: { ...analytics[item.lead_source].leadAnalytics.stage },
                call_back_reason: call_back_reason,
              },
            };
          });
        }
        dispatcher(interestedBudgetReportData(apiResponseData.data?.interested?.budget?.report));
        if (apiResponseData.data?.interested?.budget?.report) {
          apiResponseData.data.interested.budget.report.forEach((item: any) => {
            let budget: { [key: string]: number } = {};
            item.budget.forEach((val: any) => {
              budget[val.budget] = val.count;
            });
            analytics[item.lead_source] = {
              leadAnalytics: {
                budget: budget,
                stage: { ...analytics[item.lead_source].leadAnalytics.stage },
                location: {},
                project: {},
                propertyType: {},
                propertyStage: {},
                lost_reason: {},
                not_int_reason: {},
                call_back_reason: { ...analytics[item.lead_source].leadAnalytics.call_back_reason },
              },
            };
          });
        }
        dispatcher(interestedLocationReportData(apiResponseData.data?.interested?.location?.report));
        if (apiResponseData.data?.interested?.location?.report) {
          apiResponseData.data.interested.location.report.forEach((item: any) => {
            let location: { [key: string]: number } = {};
            item.location.forEach((val: any) => {
              location[val.location] = val.count;
            });
            analytics[item.lead_source] = {
              leadAnalytics: {
                location: location,
                budget: { ...analytics[item.lead_source].leadAnalytics.budget },
                stage: { ...analytics[item.lead_source].leadAnalytics.stage },
                project: {},
                propertyType: {},
                propertyStage: {},
                lost_reason: {},
                not_int_reason: {},
                call_back_reason: { ...analytics[item.lead_source].leadAnalytics.call_back_reason }
              },
            };
          });
        }
        dispatcher(interestedProjectReportData(apiResponseData.data?.interested?.project?.report));
        if (apiResponseData.data?.interested?.project?.report) {
          apiResponseData.data.interested.project.report.forEach((item: any) => {
            let project: { [key: string]: number } = {};
            item.project.forEach((val: any) => {
              project[val.project] = val.count;
            });
            analytics[item.lead_source] = {
              leadAnalytics: {
                project: project,
                location: {
                  ...analytics[item.lead_source].leadAnalytics.location,
                },
                budget: { ...analytics[item.lead_source].leadAnalytics.budget },
                stage: { ...analytics[item.lead_source].leadAnalytics.stage },
                propertyType: {},
                propertyStage: {},
                lost_reason: {},
                not_int_reason: {},
                call_back_reason: { ...analytics[item.lead_source].leadAnalytics.call_back_reason }
              },
            };
          });
        }
        dispatcher(interestedPropertyTypeReportData(apiResponseData.data?.interested?.propertyType?.report));
        if (apiResponseData.data?.interested?.propertyType?.report) {
          apiResponseData.data.interested.propertyType.report.forEach((item: any) => {
            let propertyType: { [key: string]: number } = {};
            item.property_type.forEach((val: any) => {
              propertyType[val.property_type] = val.count;
            });
            analytics[item.lead_source] = {
              leadAnalytics: {
                propertyType: propertyType,
                project: { ...analytics[item.lead_source].leadAnalytics.project },
                location: {
                  ...analytics[item.lead_source].leadAnalytics.location,
                },
                budget: { ...analytics[item.lead_source].leadAnalytics.budget },
                stage: { ...analytics[item.lead_source].leadAnalytics.stage },
                propertyStage: {},
                lost_reason: {},
                not_int_reason: {},
                call_back_reason: { ...analytics[item.lead_source].leadAnalytics.call_back_reason },
              },
            };
          });
        }
        dispatcher(interestedPropertyStageReportData(apiResponseData.data?.interested?.propertyStage?.report));
        if (apiResponseData.data?.interested?.propertyStage?.report) {
          apiResponseData.data.interested.propertyStage.report.forEach((item: any) => {
            let propertyStage: { [key: string]: number } = {};
            item.property_stage.forEach((val: any) => {
              propertyStage[val.property_stage] = val.count;
            });
            analytics[item.lead_source] = {
              leadAnalytics: {
                propertyStage: propertyStage,
                propertyType: {
                  ...analytics[item.lead_source].leadAnalytics.propertyType,
                },
                project: { ...analytics[item.lead_source].leadAnalytics.project },
                location: {
                  ...analytics[item.lead_source].leadAnalytics.location,
                },
                budget: { ...analytics[item.lead_source].leadAnalytics.budget },
                stage: { ...analytics[item.lead_source].leadAnalytics.stage },
                lost_reason: {},
                not_int_reason: {},
                call_back_reason: { ...analytics[item.lead_source].leadAnalytics.call_back_reason }
              },
            };
          });
        }
        dispatcher(lostReasonReportData(apiResponseData.data?.reasons?.lostReason?.report));
        if (apiResponseData.data?.reasons?.lostReason?.report) {
          apiResponseData.data.reasons.lostReason.report.forEach((item: any) => {
            let lost_reason: { [key: string]: number } = {};
            item.lost_reason.forEach((val: any) => {
              lost_reason[val.lost_reason] = val.count;
            });
            analytics[item.lead_source] = {
              leadAnalytics: {
                lost_reason: lost_reason,
                propertyStage: {
                  ...analytics[item.lead_source].leadAnalytics.propertyStage,
                },
                propertyType: {
                  ...analytics[item.lead_source].leadAnalytics.propertyType,
                },
                project: { ...analytics[item.lead_source].leadAnalytics.project },
                location: {
                  ...analytics[item.lead_source].leadAnalytics.location,
                },
                budget: { ...analytics[item.lead_source].leadAnalytics.budget },
                stage: { ...analytics[item.lead_source].leadAnalytics.stage },
                call_back_reason: { ...analytics[item.lead_source].leadAnalytics.call_back_reason },
                not_int_reason: {},
              },
            };
          });
        }
        dispatcher(notInterestedReportData(apiResponseData.data?.reasons?.notInterestedReason?.report));
        if (apiResponseData.data?.reasons?.notInterestedReason?.report) {
          apiResponseData.data.reasons.notInterestedReason.report.forEach((item: any) => {
            let not_int_reason: { [key: string]: number } = {};
            item.not_int_reason.forEach((val: any) => {
              not_int_reason[val.not_int_reason] = val.count;
            });
            analytics[item.lead_source] = {
              leadAnalytics: {
                not_int_reason: not_int_reason,
                lost_reason: {
                  ...analytics[item.lead_source].leadAnalytics.lost_reason,
                },
                propertyStage: {
                  ...analytics[item.lead_source].leadAnalytics.propertyStage,
                },
                propertyType: {
                  ...analytics[item.lead_source].leadAnalytics.propertyType,
                },
                project: { ...analytics[item.lead_source].leadAnalytics.project },
                location: {
                  ...analytics[item.lead_source].leadAnalytics.location,
                },
                budget: { ...analytics[item.lead_source].leadAnalytics.budget },
                stage: { ...analytics[item.lead_source].leadAnalytics.stage },
                call_back_reason: { ...analytics[item.lead_source].leadAnalytics.call_back_reason }
              },
            };
          });
        }

        //tasks
        dispatcher(pendingReportData(taskResponseData.data?.tasks?.pending?.report));
        if (taskResponseData.data?.tasks?.pending?.report) {
          taskResponseData.data?.tasks?.pending?.report.forEach((item: any) => {
            let pending: { [key: string]: number } = {};
            item.type.forEach((val: any) => {
              pending[val.type] = val.count;
              if (val.type === 'Meeting' || val.type === 'Site Visit') {
                pendingCount = pendingCount + val.count;
              }
            });
            taskAnalytics[item.owner] = {
              totalTaskCount: {
                Pending: pending,
                Overdue: { Meeting: 0, 'Call Back': 0, 'Site Visit': 0 },
                Completed: { Meeting: 0, 'Call Back': 0, 'Site Visit': 0 },
              },
            };
          });
        }

        dispatcher(overDueReportData(taskResponseData.data?.tasks?.overdue?.report));
        if (taskResponseData.data?.tasks?.overdue?.report) {
          taskResponseData.data?.tasks?.overdue?.report.forEach((item: any) => {
            let overdue: { [key: string]: number } = {};
            item.type.forEach((val: any) => {
              overdue[val.type] = val.count;
              if (val.type === 'Meeting' || val.type === 'Site Visit') {
                pendingCount = pendingCount + val.count;
              }
            });
            if (taskAnalytics[item.owner] === undefined) {
              taskAnalytics[item.owner] = {
                totalTaskCount: {
                  Pending: { Meeting: 0, 'Call Back': 0, 'Site Visit': 0 },
                  Overdue: overdue,
                  Completed: { Meeting: 0, 'Call Back': 0, 'Site Visit': 0 },
                },
              };
            } else {
              taskAnalytics[item.owner] = {
                totalTaskCount: {
                  Pending: {
                    ...taskAnalytics[item.owner].totalTaskCount.Pending,
                  },
                  Overdue: overdue,
                  Completed: { Meeting: 0, 'Call Back': 0, 'Site Visit': 0 },
                },
              };
            }
          });
        };

        dispatcher(completeTaskReportData(taskResponseData.data?.tasks?.completed?.report));
        let completedSum = 0;
        if (taskResponseData.data?.tasks?.completed?.report) {
          taskResponseData.data?.tasks?.completed?.report.forEach((item: any) => {
            let completed: { [key: string]: number } = {};
            item.type.forEach((val: any) => {
              completed[val.type] = val.count;
              if (val.type === 'Meeting' || val.type === 'Site Visit') {
                completedSum = completedSum + val.count;
              }
            });
            if (taskAnalytics[item.owner] === undefined) {
              taskAnalytics[item.owner] = {
                totalTaskCount: {
                  Pending: { Meeting: 0, 'Call Back': 0, 'Site Visit': 0 },
                  Overdue: { Meeting: 0, 'Call Back': 0, 'Site Visit': 0 },
                  Completed: completed,
                },
              };
            } else {
              taskAnalytics[item.owner] = {
                totalTaskCount: {
                  Pending: {
                    ...taskAnalytics[item.owner].totalTaskCount.Pending,
                  },
                  Overdue: {
                    ...taskAnalytics[item.owner].totalTaskCount.Overdue,
                  },
                  Completed: completed,
                },
              };
            }
          });
        }

        setTaskStage({ Completed: completedSum, Pending: pendingCount });
        setTaskAnalyticsData(taskAnalytics);

        setApiAnalyticsData(analytics);
        setLoad(false);
      })
    }

    if (analyticsPanel === 'Call Logs') {
      let filters: { [key: string]: any } = {};
      const { reporting_to, team, branch, transfer_status, ...otherContactFilter } = contactsFilter;
      Object.keys(contactsFilter).forEach((key) => {
        filters[`leads.${key}`] = contactsFilter[key];
      });
      setPassOnContactFilters(filters);
      let Tasksfilters: { [key: string]: any } = {};
      Object.keys(tasksFilter).forEach((key) => {
        Tasksfilters[`tasks.${key}`] = tasksFilter[key];
      });

      setPassOnTaskFilter(Tasksfilters);

      axios.defaults.headers.common['x-access-token'] = authToken;

      // call logs report api data
      const callLogsApiData = {
        uid: user?.auth_id,
        start_date: startDate,
        end_date: endDate,
        taskFilter: tasksFilter || {},
        leadFilter: otherContactFilter,
        leadUserFilter: {
          reporting_to,
          team,
          branch
        },
        callFilter: { ...callsFilter, transfer_status },
      };

      const callingReportPromise = await axios.post(
        url + '/analyticsCalls/dashboard/source',
        callLogsApiData
      );

      Promise.all([callingReportPromise]).then(data => {
        let callLogsRes = data[0];
        setInterestedTrendAnalytics(callLogsRes?.data?.interestedStage.ChartCount);
        dispatcher(callBackReportData(callLogsRes?.data?.calls));

        if (callLogsRes.data?.calls) {
          const obj = Object.assign({}, ...(callLogsRes.data?.calls?.ChartCount || []));
          let callsData: { [key: string]: { callLogAnalytics: {} } } = {};
          (callLogsRes.data?.calls?.report || []).forEach((item: any) => {
            let data: { [key: string]: number } = {};
            item.duration.forEach((val: any) => {
              if (val.duration === 'Other') {
                data['>120'] = val.count;
              } else {
                data[val.duration] = val.count;
              }
            });
            callsData[item.owner] = { callLogAnalytics: data };
          });

          setCallLogApiAnalyticsData(callsData);
          setCallLogAnalytics(obj);
          setLoad(false);
        }
      })
    }
  };

  useEffect(() => {
    if (organizationUsers) {
      let l: any[] = [];
      const users: { [key: string]: string } = {};

      organizationUsers.map((user: any) => {
        users[user?.uid] = user.user_first_name + ' ' + user.user_last_name;
        l.push(user.user_email);
      });

      setUsersList(users);
      setUsersEmail(l);
    }
  }, [organizationUsers]);


  useEffect(() => {
    if (callLogAnalytics) {
      const tempData: any[] = [];
      Object.values(callLogAnalytics).forEach((val: any) => {
        tempData.push(val);
      });
      setCallLogData({ data: tempData.reverse(), label: Object.keys(callLogAnalytics).reverse() });
    }
  }, [callLogAnalytics]);

  useEffect(() => {
    if (interestedTrendAnalytics) {
      const sortedDates = Object.keys(interestedTrendAnalytics).sort(
        sortDates,
      );
      const values: any[] = [];
      sortedDates.forEach((key) => {
        values.push(interestedTrendAnalytics[key]);
      });
      setInterestedData({
        data: values.reverse(),
        label: sortedDates.reverse(),
      });
    }
  }, [interestedTrendAnalytics]);

  const state = {
    labels: callLogData.label,
    datasets: [
      {
        label: 'Calling Trend',
        backgroundColor: '#4FCE5D',
        borderColor: '#4FCE5D',
        borderWidth: 2,
        data: callLogData.data,
        pointRadius: 6,
      },
    ],
  };

  const interestedState = {
    labels: interestedData.label,
    datasets: [
      {
        label: 'Interested Lead Trend',
        backgroundColor: '#1589FF',
        borderColor: '#1589FF',
        borderWidth: 2,
        data: interestedData.data,
        pointRadius: 6,
      },
    ],
  };

  useEffect(() => {
    if (apiAnalyticsData) {

      let total = 0;
      let tempCounts: { [key: string]: number } = {
        FRESH: 0,
        INTERESTED: 0,
        CALLBACK: 0,
        WON: 0,
        'NOT INTERESTED': 0,
        LOST: 0,
      };
      Object.values(apiAnalyticsData).forEach((userAnalytics: any) => {
        Object.keys(userAnalytics.leadAnalytics.stage).forEach((key) => {
          if (key !== 'Pending' && key !== 'Completed') {
            total += userAnalytics.leadAnalytics.stage[key];
          }
        });
        const analyticsCount = userAnalytics.leadAnalytics.stage;
        Object.keys(tempCounts).forEach((key) => {
          if (analyticsCount[key]) {
            tempCounts[key] += analyticsCount[key];
          }
        });
      });

      setStage(tempCounts);
      setTotal(total);
    }
  }, [apiAnalyticsData]);

  useEffect(() => {
  }, [contactsFilter, tasksFilter, callsFilter]);

  useEffect(() => {
    if (clearFilter === true) {
      setContactsFilter({});
      setTasksFilter({});
      setCallsFilter({});
      setClearFilter(false);
    }

  }, [clearFilter]);

  useEffect(() => {
    setShowMoreContactAnalytics(false);
    setShowTrendAnalytics(false);
  }, [analyticsPanel])


  const handleClearFilter = () => {
    setContactsFilter({});
    setTasksFilter({});
    setCallsFilter({});
    setFilterType("All");

    lastApiKeyRef.current = "";
    localStorage.clear();
  };

  // Responsive container styles
  const containerStyles = {
    backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark,
    color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
    padding: isMobile ? "8px" : "8px",
    minHeight: "100vh",
  };

  const analyticsTabs = {
    backgroundColor: theme ? themeColors.cardBackgroundColor : themeColors.cardBackgroundColorDark,
    borderRadius: "0.25rem",
    color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
    display: "flex",
    flexDirection: isMobile ? "column" : "row",
    alignItems: isMobile ? "stretch" : "center",
    gap: isMobile ? "8px" : "16px",
    padding: isMobile ? "8px" : "16px",
  };

  const buttonStyles = {
    backgroundColor: theme ? themeColors.cardBackgroundColor : themeColors.cardBackgroundColorDark,
    color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
    width: isMobile ? "100%" : "auto",
    marginBottom: isMobile ? "8px" : "0",
  };

  const fontFamilyMain = "var(--font-family-main)";
  const fontSizeSmall = "var(--font-size-small)";

  return (
    <Container
      maxWidth={false}
      disableGutters
      sx={{
        ...containerStyles,
        width: "100vw",
        minHeight: "100vh",
        padding: isMobile ? "0" : "24px",
        boxSizing: "border-box",
        margin: 0,
        background: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark,
        marginTop: isMobile ? "3%" : undefined,
      }}
      className={styles.parent}
    >
      {load === true && <Loading />}
      <Box
        className={styles.container}
        sx={{
          ...containerStyles,
          maxWidth: "100vw",
          margin: 0,
          boxSizing: "border-box",
          padding: isMobile ? "" : "24px",
          minHeight: "100vh",
          background: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark,
        }}
      >
        <Box
          className={styles.type}
          sx={{
            width: "100%",
            // padding: isMobile ? "8px" : "0",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              justifyContent: isMobile ? "center" : "space-between",
              gap: "8px",
              width: "100%",
              alignItems: isMobile ? "center" : "center",
              borderRadius: "0.5rem",
              position: "relative",
              zIndex: 10,
            }}
          >
            {/* Left side: Team/Source/Team Wise */}
            <Box sx={{ display: "flex", flexDirection: isMobile ? "row" : "row", alignItems: "center", gap: "8px" }}>
              <button
                className={styles.filterBox2}
                style={{
                  ...buttonStyles,
                  width: isMobile ? "unset" : "auto",
                  marginLeft: 0,
                  marginBottom: isMobile ? "8px" : "0",
                  minWidth: isMobile ? 110 : 90,
                  fontWeight: "bold",
                  fontFamily: fontFamilyMain,
                  fontSize: fontSizeSmall,
                }}
                onClick={() => {
                  setAnalyticsType('associate');
                  setSource(false);
                }}
              >
                <FaUsers color={'#272944'} size="10" style={{ marginRight: '10px' }} />
                Team
              </button>
              <button
                className={styles.filterBox2}
                style={{
                  ...buttonStyles,
                  width: isMobile ? "unset" : "auto",
                  marginLeft: 0,
                  marginBottom: isMobile ? "8px" : "0",
                  minWidth: isMobile ? 110 : 90,
                  fontWeight: "bold",
                  fontFamily: fontFamilyMain,
                  fontSize: fontSizeSmall,
                }}
                onClick={() => {
                  setAnalyticsType('source');
                  setSource(true);
                }}
              >
                <FaBook color={'#272944'} size="10" style={{ marginRight: '10px' }} />
                Source
              </button>
              {/* Replace checkbox with button */}
              <button
                className={styles.filterBox2}
                style={{
                  ...buttonStyles,
                  width: isMobile ? "unset" : "auto",
                  marginBottom: isMobile ? "8px" : "0",
                  minWidth: isMobile ? 110 : 90,
                  fontWeight: checked ? "bold" : "normal",
                  fontFamily: fontFamilyMain,
                  fontSize: fontSizeSmall,
                  backgroundColor: checked
                    ? (theme ? "#E6E6E6" : "#E6E6E6")
                    : (theme ? themeColors.cardBackgroundColor : themeColors.cardBackgroundColorDark),
                  color: checked
                    ? (theme ? "#272944" : "#272944")
                    : (theme ? themeColors.textPrimary : themeColors.textPrimaryDark),
                  border: checked ? "1px solid #272944" : undefined,
                }}
                onClick={() => setChecked(!checked)}
              >
                Team Wise
              </button>
            </Box>
            {/* Right side: Date Filter, Org Filter, Clear Filter */}
            <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "8px", position: "relative" }}>
              <button
                className={styles.filterBox}
                ref={dateFilterBtnRef}
                style={{
                  ...buttonStyles,
                  width: isMobile ? "unset" : "auto",
                  minWidth: isMobile ? 110 : 90,
                  marginBottom: isMobile ? "8px" : "0",
                  fontFamily: fontFamilyMain,
                  fontSize: isMobile ? fontSizeSmall : fontSizeSmall,
                  position: "relative",
                  zIndex: 2,
                }}
                onClick={() => setShowFilter(!showFilter)}
              >
                <FaFilter color={'#272944'} size="10" style={{ marginRight: '10px' }} />
                Date Filter
              </button>
              {/* Show filter popover below the button, centered */}
              {showFilter === true && (
                <Box
                  sx={{
                    position: "absolute",
                    left: isMobile ? "20%" : "5%",
                    transform: "translateX(-50%)",
                    top: dateFilterBtnRef.current ? dateFilterBtnRef.current.offsetHeight + 8 : 40,
                    zIndex: 10,
                    minWidth: 260,
                    boxShadow: 3,
                    background: theme ? themeColors.cardBackgroundColor : themeColors.cardBackgroundColorDark,
                    borderRadius: "8px",
                    padding: "0px",
                  }}
                >
                  <AnalyticsFilter
                    setFilterState={(data) => setFilterType(data)}
                    filterUsed={filterType}
                    showFilter={(data) => setShowFilter(data)}
                  />
                </Box>
              )}
              <button
                className={styles.filterBox}
                ref={kanbanBtnRef}
                style={{
                  ...buttonStyles,
                  width: isMobile ? "unset" : "auto",
                  minWidth: isMobile ? 110 : 90,
                  marginBottom: isMobile ? "8px" : "0",
                  fontFamily: fontFamilyMain,
                  fontSize: isMobile ? fontSizeSmall : fontSizeSmall,
                  position: "relative",
                  zIndex: 2,
                }}
                onClick={() => {
                  if (kanbanBtnRef.current) {
                    const rect = kanbanBtnRef.current.getBoundingClientRect();
                    setKanbanAnchor({
                      top: rect.bottom + window.scrollY + 8,
                      left: rect.left + window.scrollX,
                    });
                  }
                  setShowKanbanFilter(true);
                }}
              >
                <FaFilter color={'#272944'} size="10" style={{ marginRight: '10px' }} />
                {isMobile ? "Analytics" : "Analytics Filter"}
              </button>
              {showKanbanFilter && (
                <KanbanViewFilter
                  panel={analyticsPanel}
                  setCallsFilter={(data) => setCallsFilter(data)}
                  setContactsFilter={(data) => setContactsFilter(data)}
                  setTaskFilters={(data) => setTasksFilter(data)}
                  setClearFilter={(data) => setClearFilter(data)}
                  clearFilter={clearFilter}
                  usersList={usersEmail}
                  hideDateFilter={() => setShowKanbanFilter(false)}
                  onClose={() => setShowKanbanFilter(false)}
                />
              )}
              {role === "superAdmin" && (
                <button
                  className={styles.filterBox}
                  style={{
                    ...buttonStyles,
                    width: isMobile ? "unset" : "auto",
                    minWidth: isMobile ? "unset" : 90,
                    marginBottom: isMobile ? "8px" : "0"
                  }}
                  onClick={() => setShowOrgFilter(!showOrgFilter)}
                >
                  <FaFilter color={'#272944'} size="10" style={{ marginRight: '10px' }} />
                  {isMobile ? "Organization" : "Organization Filter"}
                </button>
              )}
              <button
                className={styles.filterBox}
                style={{
                  ...buttonStyles,
                  width: isMobile ? "unset" : "auto",
                  minWidth: isMobile ? 110 : 90,
                  marginBottom: isMobile ? "8px" : "0",
                  fontFamily: fontFamilyMain,
                  fontSize: isMobile ? fontSizeSmall : fontSizeSmall,
                }}
                onClick={() => handleClearFilter()}
              >
                <FaBeer color={'#272944'} size="10" style={{ marginRight: '10px' }} />
                Clear Filter
              </button>
            </Box>
          </Box>
        </Box>
        {/* Summary Cards - Horizontal scroll on mobile */}
        {!isMobile && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              overflowX: isMobile ? "auto" : "visible",
              overflowY: "hidden",
              gap: isMobile ? "8px" : "16px",
              paddingBottom: isMobile ? "20px" : "0",
              width: "100%",
              minHeight: "90px",
              alignItems: "center",
              flexShrink: 0,
              justifyContent: isMobile ? "center" : "flex-start",
            }}
          >
            <AnalyticsCountContainer
              stage={stage}
              history={history}
              filter={filterType}
              taskStage={taskStage}
              taskFilter={passOnTaskFilters}
              leadFilter={contactsFilter}
              otherContactFilter={passOnContactFilters}
              otherTaskFilter={tasksFilter} source={source} total={total}
            />
          </Box>
        )}
        {/* Feedback Table - Make horizontally scrollable on mobile */}
        <Box
          sx={{
            width: "100%",
            overflowX: isMobile ? "hidden" : "auto",
          }}
        >
          {isMobile && (
            <Box sx={{ padding: 1.5 }}>
              <AnalyticsCountContainer
                stage={stage}
                history={history}
                filter={filterType}
                taskStage={taskStage}
                taskFilter={passOnTaskFilters}
                leadFilter={contactsFilter}
                otherContactFilter={passOnContactFilters}
                otherTaskFilter={tasksFilter} source={source} total={total}
              />
            </Box>
          )}

          {analyticsPanel === 'Contacts' && (
            <>
              <FeedbackGraph
                analyticsData={apiAnalyticsData}
                usersList={usersList}
                checked={checked}
                teamsData={teamsData}
                history={history}
                filter={filterType}
                source={source}
                taskFilter={passOnTaskFilters}
                leadFilter={contactsFilter}
              />
              <CallBackReason
                analyticsData={apiAnalyticsData}
                usersList={usersList}
                checked={checked}
                teamsData={teamsData}
                history={history}
                filter={filterType}
                source={source}
                taskFilter={passOnTaskFilters}
                leadFilter={contactsFilter}
              />
            </>)}
          {analyticsPanel === 'Contacts' && showMoreContactAnalytics ?
            <>
              <InterestedBudget
                analyticsData={apiAnalyticsData}
                usersList={usersList}
                checked={checked}
                teamsData={teamsData}
                history={history}
                filter={filterType}
                source={source}
                taskFilter={passOnTaskFilters}
                leadFilter={contactsFilter}
              />
              <InterestedLocation
                analyticsData={apiAnalyticsData}
                usersList={usersList}
                checked={checked}
                teamsData={teamsData}
                history={history}
                filter={filterType}
                source={source}
                taskFilter={passOnTaskFilters}
                leadFilter={contactsFilter}
              />
              <InterestedProject
                analyticsData={apiAnalyticsData}
                usersList={usersList}
                checked={checked}
                teamsData={teamsData}
                history={history}
                filter={filterType}
                source={source}
                taskFilter={passOnTaskFilters}
                leadFilter={contactsFilter}
              />
              <LostReason
                analyticsData={apiAnalyticsData}
                usersList={usersList}
                checked={checked}
                teamsData={teamsData}
                history={history}
                filter={filterType}
                source={source}
                taskFilter={passOnTaskFilters}
                leadFilter={contactsFilter}
              />
              <NotIntReason
                analyticsData={apiAnalyticsData}
                usersList={usersList}
                checked={checked}
                teamsData={teamsData}
                history={history}
                filter={filterType}
                source={source}
                taskFilter={passOnTaskFilters}
                leadFilter={contactsFilter}
              />
            </> : null
          }
          {analyticsPanel === 'Tasks' && (
            <>
              {' '}
              <CompletedTask
                analyticsData={taskAnalyticsData}
                usersList={usersList}
                checked={checked}
                teamsData={teamsData}
                history={history}
                filter={filterType}
                source={source}
                passOnFilters={passOnContactFilters}
                tasksFilters={tasksFilter}
              />
              <PendingTask
                analyticsData={taskAnalyticsData}
                usersList={usersList}
                checked={checked}
                teamsData={teamsData}
                history={history}
                filter={filterType}
                source={source}
                passOnFilters={passOnContactFilters}
                tasksFilters={tasksFilter}
              />
              <OverdueTask
                analyticsData={taskAnalyticsData}
                usersList={usersList}
                checked={checked}
                teamsData={teamsData}
                history={history}
                filter={filterType}
                source={source}
                passOnFilters={passOnContactFilters}
                tasksFilters={tasksFilter}
              />
            </>
          )}

          {analyticsPanel === 'Call Logs' && (
            <Trends
              state={state}
              interestedState={interestedState}
              history={history}
              filter={filterType}
              analyticsData={apiCallLogAnalyticsData}
              usersList={usersList}
              checked={checked}
              teamsData={teamsData}
              source={source}
              taskFilters={passOnTaskFilters}
              leadFilters={passOnContactFilters}
              callFilters={callsFilter}
              showTrendAnalytics={showTrendAnalytics}
              setShowTrendAnalytics={setShowTrendAnalytics}
            />
          )}
          {analyticsPanel === 'Contacts' && !showMoreContactAnalytics ? (
            <Grid item xs={12} md={12} sx={{ textAlign: "center", paddingBottom: "24px" }}>
              <button className={styles.filterBox2} onClick={() => { setShowMoreContactAnalytics(!showMoreContactAnalytics) }}>Show More</button>
            </Grid>
          ) : null}
        </Box>
      </Box>
    </Container>
  );
}

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    organizationUsers: state.organizationUsers.data,
    teamLeadUsers: state.teamLeadUsers.data,
    role: state.user.role,
    branchUsers: state.branchUsers.data,
    clearfiltersideBar: state.clearFilter.clear,
    theme: state.theme.isLightMode,
    authToken: state.user.authToken,
    conatctHeader: state.contactHeaderList.data,
    organizationIdNameData: state.organizationIdNameData.data,
    analyticsPanel: state.analyticsPanel.data
  };
};

export default connect(mapStateToProps)(AdminAnalytics);